import type { AxiosResponse } from 'axios'
import { getApiErrorMessage } from '@/helpers/getApiErrorMessage'

/** Текст ошибки из ответа CRM или axios. */
export const getLeadParentApiErrorMessage = (
  responseOrError: AxiosResponse | unknown,
  fallback: string,
): string => {
  const data = (responseOrError as AxiosResponse | undefined)?.data
  if (data && typeof data === 'object' && data.status === 'error') {
    const error = (data as { error?: unknown }).error
    if (Array.isArray(error) && error[0]) {
      return String(error[0])
    }
    if (typeof error === 'string' && error) {
      return error
    }
  }

  return getApiErrorMessage(responseOrError, fallback)
}
